import { render, staticRenderFns } from "./counter.vue?vue&type=template&id=08b57009"
import script from "./counter.vue?vue&type=script&lang=js"
export * from "./counter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports